import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    deep: {
        px: {
            md: 15,
            xs: 2
        }
    },
    default: {
        boxSizing: 'border-box',
        maxWidth: '100%'
    },
    shallow: {
        px: {
            md: 6,
            xs: 2
        }
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
